"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QueryState = void 0;
exports.useNuqsNextPagesRouterAdapter = useNuqsNextPagesRouterAdapter;
var _navigation = require("next/navigation");
var _router = require("next/router");
var _react = require("react");
var _createUpdateUrl = require("../utils/createUpdateUrl");
/* istanbul ignore file @preserve --ESM only not testable (platform is working on it) */

/* eslint-disable import/extensions -- ESM only */

/* eslint-disable @typescript-eslint/no-unsafe-assignment -- ESM only */

/* eslint-disable @typescript-eslint/no-require-imports -- ESM only */

const {
  unstable_createAdapterProvider: createAdapterProviderFromfile
} = require('../nuqs-wrapper');
const createAdapter = createAdapterProviderFromfile;
function useNuqsNextPagesRouterAdapter() {
  const searchParams = (0, _navigation.useSearchParams)();
  const router = (0, _router.useRouter)();
  const updateUrl = (0, _react.useMemo)(() => (0, _createUpdateUrl.createUpdateUrl)(router), [router]);
  return {
    searchParams,
    updateUrl,
    rateLimitFactor: 2 // Ensures proper rate limiting as per Nuqs guidelines
  };
}
const QueryState = exports.QueryState = createAdapter(useNuqsNextPagesRouterAdapter);
